import { createSelector, Dispatch } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-restricted-paths
import { selectFilterState, selectMatrixFromSearchState, selectSortState } from 'component/page/search/store/search.selectors';
import { FilterMatrix } from 'gql/autogen/FilterMatrix';
import { FilterState } from 'component/common/Filter/Filter.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { OverlayType, showOverlay } from 'store/slice/overlay';
import { Sort } from 'gql/autogen/Sort';

export interface OwnProps {
    cms: CmsValue;
}

export interface StateProps {
    sort: Sort;
    filter: FilterState;
    filterMatrix: FilterMatrix;
}

export interface DispatchProps {
    openCategoriesBottomSheet: () => void;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(selectMatrixFromSearchState, selectSortState, selectFilterState, (matrix, sort, filter): StateProps => {
    const filterMatrix = matrix?.filter || {};
    return {
        sort,
        filter,
        filterMatrix,
    };
});

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    openCategoriesBottomSheet: () => dispatch(showOverlay(OverlayType.CategoriesBottomSheet)),
});
